// ---------------------------------------------------------------------
// Confidentiality Agreement submitted_at → "19th September 2026"
// formatter. Kept in its own tiny module so unit tests can pull it
// in without dragging the wider Sales-Pipeline component tree (and
// its axios ESM import chain) through the Jest transform pipeline.
// Never throws — falls back to an em-dash on malformed input so the
// admin status row degrades gracefully rather than blanking the CRM.
// ---------------------------------------------------------------------
export function formatSubmittedAt(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const day = d.getDate();
  const month = d.toLocaleString("en-GB", { month: "long" });
  const year = d.getFullYear();
  const j = day % 10;
  const k = day % 100;
  const suffix = (k >= 11 && k <= 13)
    ? "th"
    : j === 1 ? "st" : j === 2 ? "nd" : j === 3 ? "rd" : "th";
  return `${day}${suffix} ${month} ${year}`;
}
